export default __webpack_public_path__ + "static/media/BannerCategoria_X2.9f88b23a.jpg";